module.exports = __webpack_public_path__ + "img/1559382317.d80de1b7.jpg";